import { useState, useEffect } from 'react';



export enum BreakpointsEnum {
	main = 1000
}


export const useIsSmallScreen = (breakpoint: number = BreakpointsEnum.main) => {
	
	const [ isSmallScreen, setIsSmallScreen ] = useState(false);
	const checkScreenSize = () => setIsSmallScreen(window.innerWidth < breakpoint);
	
	useEffect(() => {
		checkScreenSize();
		window.addEventListener('resize', checkScreenSize);
		return () => {
			window.removeEventListener('resize', checkScreenSize);
		}
	}, []);

	return isSmallScreen;
};